// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_POST_CLIENTE,
} from './constants';

export function postCliente(cliente, resetCostoPatentamiento = false) {
  return (dispatch, getState)=>{
    const { presupuestador={} } = getState()
    const opcionesTipoDoc = ['DNI', 'CI', 'LE', 'LC']
    const defaultCliente = {
      id_cliente: '',
      nombre: '',
      apellido: '',
      email: '',
      telefono: '',
      tipoDoc: opcionesTipoDoc[0],
      documento: '',
    }

    let auxCliente = {}
    if(cliente){
      auxCliente = cliente
    } else if(presupuestador.cliente) {
      auxCliente = presupuestador.cliente
    } else {
      auxCliente = defaultCliente
    }
    
      dispatch ({
        type: PRESUPUESTADOR_POST_CLIENTE,
        data: {
          cliente: auxCliente,
          resetCostoPatentamiento,
        }
      })
    
   
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_POST_CLIENTE:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
}
